import styled from 'styled-components';
import { FlexContainer } from '@taxdown/piccolo-web';
import { Lottie } from 'Components/UI';
import { pxToRem } from 'Styles/utils/utils';
import { MOBILE_WIDTH, TABLET_WIDTH } from 'Styles/variables/sizes';

export const StyledFlexContainer = styled(FlexContainer)`
  border-radius: 5px;
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.25);
  border: 1px solid ${({ theme: { colors } }) => colors.lightBlack};
  padding: ${pxToRem(30)};
  @media screen and (max-width: ${TABLET_WIDTH}) {
    padding: ${pxToRem(20)};
    flex-direction: column;
    align-items: flex-start;
  }
`;

export const ProgressWrapper = styled.div`
  width: 90%;
`;

export const ButtonsWrapper = styled(FlexContainer)`
  flex-direction: column;
  align-items: center;
  padding-top: ${({ theme: { reference } }) => reference.dimension_08};
  padding-bottom: ${({ theme: { reference } }) => reference.dimension_16};
  @media screen and (max-width: ${MOBILE_WIDTH}) {
    width: 90%;
    > div {
      button {
        width: 100%;
      }
    }
    > div:first-child {
      button {
        margin-right: 0;
        margin-bottom: ${pxToRem(20)};
      }
    }
  }
`;

export const StyledLottie = styled(Lottie)`
  width: 100%;
  max-width: 300px;
  @media screen and (max-width: ${MOBILE_WIDTH}) {
    max-width: 200px;
  }
`;

export const KiteLottie = styled(Lottie)`
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  z-index: -1;
  svg {
    opacity: 0.2;
  }
`;

export const ImageContainer = styled.div`
  width: 100%;
  max-width: ${pxToRem(218)};
  img {
    width: 100%;
  }
`;

export const InfoContainer = styled(FlexContainer)`
  padding-top: ${({ theme: { reference } }) => reference.dimension_16};
`;
